import { render } from "./AppLayoutMain.vue?vue&type=template&id=68ec2600&scoped=true"
import script from "./AppLayoutMain.vue?vue&type=script&lang=js"
export * from "./AppLayoutMain.vue?vue&type=script&lang=js"

import "./AppLayoutMain.vue?vue&type=style&index=0&id=68ec2600&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ec2600"]])

export default __exports__